import {Component, OnInit, ElementRef} from '@angular/core';

@Component({
    selector: 'world-map-chart',
    templateUrl: 'world-map-chart.component.html',
    styleUrls: ['world-map-chart.component.css']
})
export class WorldMapChartComponent implements OnInit {

    data = [
        ['BR', 0, 1, 27],
        ['RU', 1, 2, 16],
        ['RO', 2, 0, 105],
        ['IN', 3, 2, 10],
        ['CN', 2, 1, 39],
        ['US', 3, 2, 11],
        ['DE', 3, 0, 68],
        ['US', 3, 2, 14],
        ['AU', 2, 1, 34]
    ];

    risks = ['HIGH', 'MEDIUM', 'LOW', 'INFO'];
    riskClasses = ['bg-risk-high', 'bg-risk-medium', 'bg-risk-low', 'bg-risk-info'];

    volumes = ['HIGH', 'MEDIUM', 'LOW'];
    volClasses = ['bg-vol-high', 'bg-vol-medium', 'bg-vol-low'];

    blankTooltip: any = {
        left: -1000,
        top: -1000,
        width: 160,
        data: []
    };
    tooltip: any = Object.assign({}, this.blankTooltip);

    constructor(private element: ElementRef) {
    }

    ngOnInit() {

        const self = this;

        this.data.forEach(function (d) {

            const country = self.element.nativeElement.querySelector('#' + d[0]);
            country.setAttribute('class', self.riskClasses[d[1]] + ' ' + self.volClasses[d[2]]);
            country.addEventListener('mouseover', (evt) => {
                self.onCountryMouseOver(evt, d);
            });
            country.addEventListener('mouseout', (evt) => {
                self.onCountryMouseOut();
            });

        });


    }

    onCountryMouseOver(evt, data) {
        this.tooltip.data = data;
        this.tooltip.left = evt.clientX - (this.tooltip.width / 2);
        this.tooltip.top = evt.clientY;
    }

    onCountryMouseOut() {
        this.tooltip = Object.assign({}, this.blankTooltip);
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/world-map-chart/world-map-chart.component.ts